function hex(c) {
    var s = "0123456789abcdef";
    var i = parseInt(c);
    if (i == 0 || isNaN(c))
        return "00";
    i = Math.round(Math.min(Math.max(0, i), 255));
    return s.charAt((i - i % 16) / 16) + s.charAt(i % 16);
}

/* Convert an RGB triplet to a hex string */
function convertToHex(rgb) {
    return hex(rgb[0]) + hex(rgb[1]) + hex(rgb[2]);
}

/* Remove '#' in color hex string */
function trim(s) { return (s.charAt(0) == '#') ? s.substring(1, 7) : s }

/* Convert a hex string to an RGB triplet */
function convertToRGB(hex) {
    var color = [];
    color[0] = parseInt((trim(hex)).substring(0, 2), 16);
    color[1] = parseInt((trim(hex)).substring(2, 4), 16);
    color[2] = parseInt((trim(hex)).substring(4, 6), 16);
    return color;
}

export const generateColor = (colorStart, colorEnd, colorMiddle, intensity = -0.2, showMiddleColor = false, colorCount = 6) => {

    // The beginning of your gradient
    var startS = convertToRGB(colorStart);
    var startE = convertToRGB(colorEnd);

    // The end of your gradient
    var end;
    if (colorMiddle) {
        end = convertToRGB(colorMiddle);
    } else {
        const newMColor = (Number(colorStart.replace('#', '0x')) + Number(colorEnd.replace('#', '0x'))) / 2;
        end = convertToRGB(`#${Math.round(newMColor).toString(16)}`);
    }

    // The number of colors to compute
    var len = colorCount;
    var totalLenght = colorCount * 2;

    //Alpha blending amount
    // var alpha = 0.0;

    var saida = [];

    if (showMiddleColor) saida[len] = colorMiddle;

    const _1 = 1;

    for (let i = 0; i < len; i++) {
        var cS = [];
        var cE = [];
        var alpha = (1.0 / len) * ((len - i));

        cS[0] = startS[0] * alpha + (_1 - alpha) * (end[0] * (1 + intensity));
        cS[1] = startS[1] * alpha + (_1 - alpha) * (end[1] * (1 + intensity));
        cS[2] = startS[2] * alpha + (_1 - alpha) * (end[2] * (1 + intensity));


        cE[0] = startE[0] * alpha + (_1 - alpha) * (end[0] * (1 + intensity));
        cE[1] = startE[1] * alpha + (_1 - alpha) * (end[1] * (1 + intensity));
        cE[2] = startE[2] * alpha + (_1 - alpha) * (end[2] * (1 + intensity));

        saida[i] = `#${convertToHex(cS)}`;

        if (showMiddleColor) {
            saida[(totalLenght) - i] = `#${convertToHex(cE)}`;
        } else {
            saida[(totalLenght) - i - 1] = `#${convertToHex(cE)}`;
        }
    }

    return saida;
}